module.exports = __webpack_public_path__ + "img/appIcon-ui--tableSortDown.36192a43.svg";